/** @file treeMenu: the right-click menu of one node row, a thin builder over the shell's menu registry. */
import type { EditorStore, MenuItem } from '../../state/editorTypes';
import { buildMenu } from '../../shell/menu/buildMenu';
import type { NodeViewOps } from '../../shell/menu/registryTypes';
import { treeUiOps } from '../../shell/menu/treeUiOps';

/** The registry's node-row menu for `name` (the same rows as that joint in the viewport); `confirm` guards the removal. */
export function treeMenu(store: EditorStore, name: string, confirm: (text: string) => boolean, view: NodeViewOps | undefined = treeUiOps(store)): MenuItem[] {
  return buildMenu('node-row', { store, surface: 'tree', node: name, confirm, ...(view === undefined ? {} : { view }) });
}
